
import { Document, Page, pdf, Text, View } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import moment from "moment"
import { ListType } from "pages/Purchase/Register/types"
import { cellValuePdf, RowExportTypePdf } from "types"
import { convertNumber } from "utils"

type UseExportPdf = {
  data: ListType[]
  dateFilter: string
}

export const useExportPdf = ({
  data,
  dateFilter
}: UseExportPdf) => {

  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "PO ID#", key: "po_id", width: 25 },
    { header: "DATE", key: "date", width: 15 },
    { header: "VENDOR", key: "vendor", width: 15 },
    { header: "APPROVAL", key: "approval", width: 15 },
    { header: "DELIVERED", key: "delivered", width: 15 },
    { header: "QTY ORDER", key: "qty_order", width: 15 },
    { header: "QTY DELIVERED", key: "qty_delivered", width: 15 },
    { header: "QTY BACK ORDER", key: "qty_back_order", width: 15 },
    { header: "TOTAL PURCHASE", key: "total_purchase", width: 15 },
    { header: "TOTAL PAYMENT", key: "total_payment", width: 15 },
    { header: "BALANCE OWING", key: "balance_owing", width: 15 }
  ]

  function numberFormat(value: number): cellValuePdf {
    return {
      text: convertNumber(value).intoCurrency,
      style: {
        textAlign: "right",
        fontWeight: "bold"
      }
    }
  }

  const calculate = data.reduce(
    (acc, item) => {
      return {
        balance: acc.balance + item.balance_owing,
        payment: acc.payment + item.total_payment
      }
    },
    { balance: 0, payment: 0 }
  )

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    return {
      no: (index + 1).toString(),
      po_id: item.trx_code,
      date: moment(item.transaction_date).format("DD/MM/YYYY"),
      vendor: item.vendor_name,
      approval: item.approval,
      delivered: item.delivery,
      qty_order: numberFormat(item.qty_order),
      qty_delivered: numberFormat(item.qty_delivered),
      qty_back_order: numberFormat(item.qty_back_order),
      total_sales: numberFormat(item.total_purchase),
      total_payment: numberFormat(item.total_payment),
      balance_owing: numberFormat(item.balance_owing)
    }
  })

  return {
    handleExportPdf: () =>
      pdf(
        <PdfTemplate
          data={dataMap}
          column={columns}
          date={dateFilter}
          balance={calculate.balance}
          payment={calculate.payment}
        />
      )
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = `register-by-date-range-${dateFilter}.pdf`
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        })
  }
}

function PdfTemplate({
  data,
  column,
  date,
  balance,
  payment
}: {
  data: RowExportTypePdf[]
  column: { header: string; key: string; width: number }[]
  date?: string
  balance: number
  payment: number
}) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>PURCHASE</Text>
        <Text style={styles.title}>REGISTER BY DATE RANGE</Text>
        {date && <Text style={styles.date}>Date: {date}</Text>}
        <TableCell data={data} column={column} />
        <View
          style={{
            marginTop: 10,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end"
          }}>
          <View
            style={[
              styles.date,
              {
                display: "flex",
                flexDirection: "row",
                fontSize: 8
              }
            ]}>
            <Text>SUMMARY PAYMENT:</Text>
            <Text style={{ width: 50, textAlign: "right", paddingLeft: 2 }}>
              {convertNumber(payment).intoCurrency}
            </Text>
          </View>

          <View
            style={[
              styles.date,
              {
                display: "flex",
                flexDirection: "row",
                fontSize: 8
              }
            ]}>
            <Text>SUMMARY BALANCE:</Text>
            <Text style={{ width: 50, textAlign: "right", paddingLeft: 2 }}>
              {convertNumber(balance).intoCurrency}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  )
}
